import cx from 'classnames';
import Proptypes from 'prop-types';

import { TITLE_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { TITLE_TAG_NAME } from './constants';
import styles from './Title.css';

const renderer = ({
  node: { type },
  TITLE_TAG = TITLE_TAG_NAME,
  ...attributes
} = {}) => {
  if (type === TITLE_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      className,
      ...restOfAttributes
    } = attributes;

    return (
      <TITLE_TAG
        {...restOfAttributes}
        className={cx(styles.title, className)}
        data-editor-plugin="title"
      >
        {children}
      </TITLE_TAG>
    );
  }
};

renderer.propTypes = {
  attributes: Proptypes.object,
  className: Proptypes.string,
  node: Proptypes.object,
  TITLE_TAG: Proptypes.node,
};

export { renderer };
